import angular from 'angular';

angular.module('cxTaskflow').directive('cxAssignedToXedit', function() {
  return {
    restrict: 'E',
    template: `<a editable-assigned-to="vm.value"
                  onbeforesave="vm.beforeSave({$data:$data})"
                  onaftersave="vm.afterSave({$data:$data})"
                  e-users="vm.users"
                  e-profiles="vm.profiles"
                  edit-disabled="vm.disabled"
                  e-placeholder="{{vm.unassignedLabel}}"
                  blur="submit">
                    <span ng-if="!vm.value || vm.value.assignedType===0" ng-bind="vm.getUnassingedLabel()" ng-class="{'text-danger':vm.showWarning}"></span>
                    <span ng-if="vm.value && vm.value.assignedType===1" ng-class="{'text-danger':vm.showWarning}">{{vm.getProfileLabel(vm.value.profile)}}</span>
                    <span ng-if="vm.value && vm.value.assignedType===2" ng-class="{'text-danger':vm.showWarning}">{{vm.getUserName(vm.value.userId)}}</span>
              </a>`,
    scope: {
      value:
        '=data' /* should be object with (at least) these properties: assignedType, userId, profile */,
      unassignedLabel: '@',
      fallback: '=',
      beforeSave: '&',
      afterSave: '&',
      disabled: '=?',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: [
      '$scope',
      '$rootScope',
      '$translate',
      'enumCacheSvc',
      'dataCache',
      'translateListFilter',
      function($scope, $rootScope, $translate, enumCacheSvc, dataCache, translateListFilter) {
        const vm = this;
        vm.users = [];
        vm.allUsers = [];
        vm.profiles = [];
        vm.showWarning = false;

        function translateProfiles() {
          vm.profiles.forEach(p => {
            p.label = translateListFilter(p.id, 'employeeprofile', p.value);
          });
        }
        vm.getProfileLabel = function(profile) {
          if (!profile) return null;
          const prof = vm.profiles.find(p => p.id === profile);
          vm.showWarning = false;
          return prof ? prof.label : '/';
        };
        vm.getUserName = function(userId) {
          if (!userId) return null;
          const user = vm.allUsers.find(u => u.id === userId);
          vm.showWarning = !user || !user.isActive;
          return user ? user.label : '/';
        };
        vm.getUnassingedLabel = function() {
          vm.showWarning = false;
          if (!vm.fallback || !vm.fallback.assignedType) return vm.unassignedLabel;
          if (vm.fallback.assignedType === 1) return vm.getProfileLabel(vm.fallback.profile);
          if (vm.fallback.assignedType === 2) return vm.getUserName(vm.fallback.userId);
          return vm.unassignedLabel;
        };
        vm.$onInit = function() {
          enumCacheSvc.get('employeeprofile').then(function(data) {
            vm.profiles = data.map(({ key, value }) => ({ id: key, value, label: value }));
            translateProfiles();
          });
          
          dataCache.ready().then(function() {
            vm.allUsers = dataCache.getArray('user').map(u => ({
              id: u.userID,
              label: `${u.firstName} ${u.lastName}`,
              isActive: u.isActive,
              hidden: u.hidden,
            }));
            vm.users = vm.allUsers.filter(x => x.isActive || !x.hidden);
          });
        };

        var deregistration = $rootScope.$on('$translateChangeSuccess', translateProfiles);
        $scope.$on('$destroy', deregistration);
      },
    ],
  };
});
